import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

export default function HeroSection({ onExploreCatalog, onContact }) {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-grid">
          <div>
            <div className="badge badge-brand" style={{ marginBottom: '1.25rem' }}>
              <Sparkles size={14} />
              Modelos Sob Assinatura
            </div>
            
            <h1 className="hero-title">
              Sua marca com presença digital <span className="text-gradient">de alto padrão</span>
            </h1>

            <p className="hero-subtitle">
              Oferecemos um catálogo exclusivo de landing pages prontas e otimizadas para diversos nichos — de ateliês de artesanato a clínicas de saúde e oficinas mecânicas. Escolha o seu modelo sob assinatura e comece a vender mais hoje mesmo.
            </p>

            <div className="hero-actions">
              <button className="btn btn-primary btn-lg" onClick={onExploreCatalog}>
                Explorar Catálogo Completo
                <ArrowRight size={18} />
              </button>
              <button className="btn btn-secondary btn-lg" onClick={() => {
                document.getElementById('pricing-section')?.scrollIntoView({ behavior: 'smooth' });
              }}>
                Ver Planos &amp; Preços
              </button>
            </div>

            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">100%</span>
                <span className="stat-label">Modelos Responsivos</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Suporte e Atualizações</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">0</span>
                <span className="stat-label">Taxas de Setup Ocasionais</span>
              </div>
            </div>
          </div>

          <div className="hero-preview-card">
            <div className="hero-mockup-browser">
              <div className="browser-bar">
                <div className="browser-dot red"></div>
                <div className="browser-dot yellow"></div>
                <div className="browser-dot green"></div>
                <div className="browser-address">https://suzumetech.com.br/modelos-demo</div>
              </div>
              <div className="mockup-body" style={{ background: 'linear-gradient(135deg, #0b132b 0%, #1c2541 100%)', color: '#ffffff' }}>
                <img 
                  src="/img/logo_suzume_horizontal.png" 
                  alt="Suzume Technologies Logo" 
                  style={{ height: '38px', width: 'auto', marginBottom: '1.25rem', filter: 'brightness(0) invert(1)' }} 
                  onError={(e) => e.target.style.display = 'none'}
                />
                <h3 style={{ color: '#ffffff', fontSize: '1.4rem', marginBottom: '0.5rem' }}>Suzume Technologies</h3>
                <p style={{ fontSize: '0.85rem', color: '#94a3b8', maxWidth: '320px', marginBottom: '1.25rem' }}>
                  Modelos de alta conversão adaptados para a sua identidade visual e nicho de atuação.
                </p>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                  <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.25rem 0.65rem', borderRadius: '20px', fontSize: '0.75rem' }}>✓ Artesanato</span>
                  <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.25rem 0.65rem', borderRadius: '20px', fontSize: '0.75rem' }}>✓ Mecânica</span>
                  <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.25rem 0.65rem', borderRadius: '20px', fontSize: '0.75rem' }}>✓ Saúde</span>
                  <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.25rem 0.65rem', borderRadius: '20px', fontSize: '0.75rem' }}>✓ E muito mais</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
